import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belagaumtomudholtaxi() {



    const cardData = {




keyword: "Belgaum to Mudhol Taxi",

headingDescription: "Belgaum Taxi Service provides comfortable and reliable Belgaum to Mudhol taxi services for business travel, family visits, local transportation, medical trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Mudhol, we offer safe and convenient travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel requirements. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to make your journey smooth and hassle-free. Belgaum Taxi Service connects passengers between Belgaum and Mudhol with affordable taxi solutions for individuals, families, and business travelers across Karnataka.",

topPlaces: [
  {
    title: "Mudhol",
    description: "Mudhol is a historic town in Bagalkot district known for the famous Mudhol Hound breed, royal heritage, agriculture, and local markets. It is a frequently traveled destination from Belgaum."
  },
  {
    title: "Bagalkot",
    description: "Bagalkot is an important city in Karnataka known for heritage attractions, business activities, and nearby historical destinations like Badami and Aihole."
  },
  {
    title: "Badami",
    description: "Badami is a famous heritage destination known for ancient cave temples, sandstone cliffs, and Chalukyan architecture, attracting tourists and history lovers."
  },
  {
    title: "Aihole",
    description: "Aihole is a historic village famous for ancient temples and architectural monuments, making it a popular destination for heritage and educational tours."
  },
  {
    title: "Pattadakal",
    description: "Pattadakal is a UNESCO World Heritage Site known for beautiful temples and historical monuments showcasing Karnataka's rich cultural heritage."
  },
  {
    title: "Bijapur",
    description: "Bijapur is a historic city famous for Gol Gumbaz, ancient monuments, and architectural landmarks. It is a popular destination for sightseeing and family trips."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination known for beaches, resorts, churches, and sightseeing attractions. Private cabs provide comfortable travel for vacation trips."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra. Travelers prefer private taxis for business trips, family visits, and interstate travel."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with major business districts, airports, and tourist attractions. Comfortable cab services provide reliable long-distance connectivity."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage Site famous for ancient ruins, temples, and historical landscapes, making it a preferred tourist destination in Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Mudhol Taxi",
    "description": "Book Belgaum to Mudhol Taxi for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Get convenient taxi services for personal trips, business travel, family visits, and regular transportation needs with flexible booking options."
  },
  {
    "name": "Belgaum to Mudhol Cab",
    "description": "Hire Belgaum to Mudhol Cab for affordable and comfortable transportation between both locations. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs with experienced drivers and smooth travel facilities."
  },
  {
    "name": "Belgaum to Mudhol Taxi Service",
    "description": "Choose Belgaum to Mudhol Taxi Service for dependable travel solutions with doorstep pickup, transparent pricing, and professional chauffeurs. Our taxi services are suitable for family journeys, business trips, and outstation travel."
  },
  {
    "name": "Belgaum to Mudhol Cab Service",
    "description": "Book Belgaum to Mudhol Cab Service for reliable intercity transportation with clean AC vehicles and trained drivers. Enjoy comfortable rides with flexible one way and round trip cab options."
  },
  {
    "name": "Belgaum to Mudhol One Way Cab",
    "description": "Reserve Belgaum to Mudhol One Way Cab for economical point-to-point travel without return charges. Get affordable fares, comfortable vehicles, and professional driver assistance for a hassle-free journey."
  },
  {
    "name": "Belgaum to Mudhol One Way Taxi",
    "description": "Choose Belgaum to Mudhol One Way Taxi for budget-friendly single destination travel. Enjoy convenient pickup, clean vehicles, and experienced chauffeurs for smooth transportation."
  },
  {
    "name": "Belgaum to Mudhol Cab Booking",
    "description": "Complete Belgaum to Mudhol Cab Booking with easy online reservations and quick confirmation. Select your preferred vehicle according to passenger count, luggage space, and travel requirements."
  },
  {
    "name": "Belgaum to Mudhol Taxi Booking",
    "description": "Book Belgaum to Mudhol Taxi Booking services for comfortable and reliable transportation. Enjoy affordable pricing, flexible travel options, and professional drivers for safe journeys."
  },
  {
    "name": "Belgaum to Mudhol Car Rental",
    "description": "Choose Belgaum to Mudhol Car Rental with driver for flexible travel solutions. Hire comfortable cars for family visits, business travel, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Mudhol Outstation Cab",
    "description": "Travel with Belgaum to Mudhol Outstation Cab services offering safe and comfortable intercity transportation. Get experienced chauffeurs, AC vehicles, and flexible travel packages."
  },
  {
    "name": "Belgaum to Mudhol Innova Crysta Cab",
    "description": "Book Belgaum to Mudhol Innova Crysta Cab for premium and spacious travel. Enjoy luxury seating, extra luggage capacity, and comfortable journeys for families, groups, and corporate passengers."
  },
  {
    "name": "Belgaum to Mudhol Ertiga Cab",
    "description": "Hire Belgaum to Mudhol Ertiga Cab for affordable 6 to 7 seater travel. Perfect for family trips, group journeys, airport transfers, and comfortable outstation transportation."
  },
  {
    "name": "Belgaum to Mudhol Sedan Cab",
    "description": "Choose Belgaum to Mudhol Sedan Cab for economical and comfortable transportation. Travel in clean AC sedans with professional drivers suitable for business and personal journeys."
  },
  {
    "name": "Belgaum to Mudhol Round Trip Cab",
    "description": "Book Belgaum to Mudhol Round Trip Cab for convenient return travel with affordable packages. Ideal for family visits, business requirements, sightseeing, and planned trips."
  },
  {
    "name": "Belgaum to Mudhol Private Taxi",
    "description": "Hire Belgaum to Mudhol Private Taxi for personalized travel with dedicated vehicles and professional chauffeurs. Enjoy privacy, comfort, and flexible schedules throughout your journey."
  },
  {
    "name": "Cheap Belgaum to Mudhol Taxi",
    "description": "Find Cheap Belgaum to Mudhol Taxi services with affordable fares and quality vehicles. Travel safely with reliable drivers without compromising comfort and service quality."
  },
  {
    "name": "Best Belgaum to Mudhol Taxi Service",
    "description": "Choose the Best Belgaum to Mudhol Taxi Service with premium vehicles, experienced chauffeurs, and competitive pricing. Get dependable transportation solutions for families, individuals, and businesses."
  },
  {
    "name": "Online Belgaum to Mudhol Cab Booking",
    "description": "Book Online Belgaum to Mudhol Cab Booking services with easy reservations and instant confirmation. Select from multiple cab options for comfortable and convenient travel."
  },
  {
    "name": "Belgaum to Mudhol Taxi Fare",
    "description": "Get affordable Belgaum to Mudhol Taxi Fare with transparent pricing and flexible packages. Choose suitable vehicle options based on your travel needs and budget."
  },
  {
    "name": "Belgaum to Mudhol Car Hire",
    "description": "Hire Belgaum to Mudhol Car Hire services with reliable vehicles and professional drivers. Suitable for family travel, corporate visits, sightseeing, and personal transportation."
  },
  {
    "name": "Belgaum to Mudhol Cab Price",
    "description": "Check Belgaum to Mudhol Cab Price and select affordable travel options. Get comfortable AC cabs with flexible booking facilities for one way and round trip journeys."
  },
  {
    "name": "Belgaum to Mudhol Family Cab",
    "description": "Book Belgaum to Mudhol Family Cab for safe and spacious travel. Enjoy comfortable seating, experienced drivers, and convenient transportation for family trips and personal visits."
  },
  {
    "name": "Belgaum to Mudhol Corporate Taxi",
    "description": "Choose Belgaum to Mudhol Corporate Taxi services for business travel and professional transportation. Get punctual service, reliable vehicles, and experienced chauffeurs for corporate requirements."
  },
  {
    "name": "Belgaum to Mudhol Airport Transfer",
    "description": "Book Belgaum to Mudhol Airport Transfer service for timely pickup and drop facilities. Travel comfortably with professional drivers and well-maintained vehicles."
  },
  {
    "name": "Belgaum to Mudhol Cab Fare",
    "description": "Get details about Belgaum to Mudhol Cab Fare with affordable rates and multiple vehicle choices. Book Sedan, Ertiga, Innova Crysta, or SUV cabs according to your requirements."
  },
  {
    "name": "Belgaum to Mudhol Taxi Near Me",
    "description": "Find Belgaum to Mudhol Taxi Near Me for quick and reliable taxi availability. Book comfortable cabs with experienced drivers for safe and convenient travel."
  },
  {
    "name": "Belgaum to Mudhol Outstation Taxi",
    "description": "Hire Belgaum to Mudhol Outstation Taxi for comfortable long-distance travel with clean vehicles and professional chauffeurs. Enjoy reliable transportation for personal, family, and business journeys."
  },
  {
    "name": "Belgaum to Mudhol Travel by Cab",
    "description": "Travel from Belgaum to Mudhol by Cab with convenient booking options, comfortable vehicles, and experienced drivers. Enjoy smooth and stress-free transportation for your complete journey."
  },
  {
    "name": "Mudhol Taxi Service",
    "description": "Book Mudhol Taxi Service for reliable local and outstation transportation with comfortable vehicles and professional drivers. Get affordable taxi solutions for family trips, business travel, railway transfers, and nearby destinations."
  }
],
"tableData": [
  ["Belgaum to Mudhol Taxi", "Belgaum to Mudhol Cab"],
  ["Belgaum to Mudhol Taxi Service", "Belgaum to Mudhol Cab Service"],
  ["Belgaum to Mudhol One Way Cab", "Belgaum to Mudhol One Way Taxi"],
  ["Belgaum to Mudhol Cab Booking", "Belgaum to Mudhol Taxi Booking"],
  ["Belgaum to Mudhol Car Rental", "Belgaum to Mudhol Outstation Cab"],
  ["Belgaum to Mudhol Innova Crysta Cab", "Belgaum to Mudhol Ertiga Cab"],
  ["Belgaum to Mudhol Sedan Cab", "Belgaum to Mudhol Round Trip Cab"],
  ["Belgaum to Mudhol Private Taxi", "Cheap Belgaum to Mudhol Taxi"],
  ["Best Belgaum to Mudhol Taxi Service", "Online Belgaum to Mudhol Cab Booking"],
  ["Belgaum to Mudhol Taxi Fare", "Belgaum to Mudhol Car Hire"],
  ["Belgaum to Mudhol Cab Price", "Belgaum to Mudhol Family Cab"],
  ["Belgaum to Mudhol Corporate Taxi", "Belgaum to Mudhol Airport Transfer"],
  ["Belgaum to Mudhol Cab Fare", "Belgaum to Mudhol Taxi Near Me"],
  ["Belgaum to Mudhol Outstation Taxi", "Belgaum to Mudhol Travel by Cab"],
  ["Mudhol Taxi Service", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Mudhol Taxi Service",
    WhyChoosedescription: "Travel comfortably from Belgaum to Mudhol with a convenient taxi service offering skilled drivers, clean vehicles, and flexible travel options for personal and professional journeys."
  },
  {
    WhyChooseheading: "Direct Pickup & Drop Convenience",
    WhyChoosedescription: "Get hassle-free transportation with pickup from your preferred location in Belgaum and direct drop service anywhere in Mudhol."
  },
  {
    WhyChooseheading: "Cars Available for Different Requirements",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs depending on your group size and comfort needs."
  },
  {
    WhyChooseheading: "Perfect for Family & Work Travel",
    WhyChoosedescription: "Our Belgaum to Mudhol taxis are suitable for family visits, business trips, personal work, medical travel, and regular transportation needs."
  },
  {
    WhyChooseheading: "Experienced Drivers for Comfortable Journey",
    WhyChoosedescription: "Professional chauffeurs ensure smooth navigation, timely service, and a relaxed travel experience throughout the Belgaum to Mudhol route."
  },
  {
    WhyChooseheading: "One Way & Return Trip Options",
    WhyChoosedescription: "Plan your journey with a one-way drop taxi or choose a return cab package according to your schedule and travel requirements."
  },
  {
    WhyChooseheading: "Well-Maintained Taxi Fleet",
    WhyChoosedescription: "Enjoy a comfortable ride with clean interiors, properly serviced vehicles, and suitable options for short and long-distance travel."
  },
  {
    WhyChooseheading: "Easy Cab Booking Support",
    WhyChoosedescription: "Get quick assistance for vehicle availability, fare details, and booking arrangements for your Belgaum to Mudhol taxi."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Mudhol Taxi Service?",
    answer: "Yes, we provide Belgaum to Mudhol taxi services with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Mudhol?",
    answer: "Yes, one-way taxi service is available for passengers who need direct travel between Belgaum and Mudhol."
  },
  {
    question: "Which cars are available for Belgaum to Mudhol travel?",
    answer: "You can choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, and SUV cabs according to your requirements."
  },
  {
    question: "Is Belgaum to Mudhol cab suitable for family travel?",
    answer: "Yes, comfortable vehicles with spacious seating are available for families and groups travelling between both locations."
  },
  {
    question: "Can I book a return cab from Mudhol to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings based on your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop facilities are available from Belgaum Airport, Railway Station, hotels, and other locations in Belgaum."
  },
  {
    question: "Can I hire a private taxi from Belgaum to Mudhol?",
    answer: "Yes, private cab services are available with dedicated vehicles and professional drivers."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are communicated during booking."
  },
  {
    question: "Is Belgaum to Mudhol taxi available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Mudhol Taxi?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback: "The Belgaum to Mudhol taxi service was comfortable and reliable. The driver was on time, and the vehicle condition was excellent.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Desai",
    feedback: "We had a smooth journey with professional service and a clean cab. The entire travel experience was convenient and stress-free.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Mudhol Taxi",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-mudhol-taxi.webp",
  "description":
    "Book Belgaum to Mudhol Taxi with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Mudhol with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for local travel, business trips, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-mudhol-taxi"
  }
};


    return (
        <div>




<Helmet>
  <title>Belgaum to Mudhol Taxi | One Way Cab Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Mudhol Taxi with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Mudhol with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable local and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Mudhol Taxi, Belgaum to Mudhol Cab, Belgaum to Mudhol Taxi Service, Belgaum to Mudhol Cab Service, Belgaum to Mudhol One Way Cab, Belgaum to Mudhol One Way Taxi, Belgaum to Mudhol Cab Booking, Belgaum to Mudhol Taxi Booking, Belgaum to Mudhol Car Rental, Belgaum to Mudhol Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belagaumtomudholtaxi;